import React from 'react';

export const SohoVibeContext = React.createContext({
  isReviewRequested: false
});
